import CutAndStyle from './images/CutAndStyle.jpg'
import BreadTrim from './images/beard-trim.jpg'
import CutStyleBeard from './images/CutStyleBeard.jpg'
import KidsCut from './images/KidsCut.jpg'

export const offeredServices = [
    {
        id: 1,
        title: "Cut and Style",
        img: CutAndStyle,
        price: 19,
        info: "Crucifix dreamcatcher hoodie tousled. XOXO sriracha hella fashion axe. Distillery brunch ethical pop-up migas celiac, yuccie meditation wolf subway tile shabby chic everyday carry semiotics.",
    },
    {
        id: 2,
        title: "Beard Trim",
        img: BreadTrim,
        price: 15,
        info: "Crucifix dreamcatcher hoodie tousled. XOXO sriracha hella fashion axe. Distillery brunch ethical pop-up migas celiac, yuccie meditation wolf subway tile shabby chic everyday carry semiotics.",
    },
    {
        id: 3,
        title: "Cut, Style, and Beard Trim",
        img: CutStyleBeard,
        price: 25,
        info: "Crucifix dreamcatcher hoodie tousled. XOXO sriracha hella fashion axe. Distillery brunch ethical pop-up migas celiac, yuccie meditation wolf subway tile shabby chic everyday carry semiotics.",
    },
    {
        id: 4,
        title: "Kid's Cut",
        img: KidsCut,
        price: 15,
        info: "Crucifix dreamcatcher hoodie tousled. XOXO sriracha hella fashion axe. Distillery brunch ethical pop-up migas celiac, yuccie meditation wolf subway tile shabby chic everyday carry semiotics.",
    },
]